package pl.mothdigital.neuronowi.common.model

import androidx.compose.runtime.Composable

/**
 * Model danych reprezentujący specjalizację specjalisty
 * 
 * @param icon Ikona specjalizacji (Composable function)
 * @param title Tytuł specjalizacji
 * @param description Opis specjalizacji
 */
data class SpecialistData(
    val icon: @Composable () -> Unit,
    val title: String,
    val description: String
) 